<template>
  <v-dialog v-model="show" max-width="450">
    <v-card>
      <v-card-title class="justify-center purple--text title" v-if="header">{{header}}</v-card-title>
      <v-card-text class="text-xs-center" v-if="message">{{message}}</v-card-text>
      <v-card-actions v-if="buttonText" class="justify-center">
        <v-btn color="purple" dark @click="closeModal">{{buttonText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "showModal",
  props: {
    value: Boolean,
    message: String,
    header: String,
    buttonText: String
  },
  data: () => ({
    show: false
  }),
  methods: {
    closeModal() {
      this.show = false;
    }
  },
  mounted() {
    this.show = this.value;
  },
  watch: {
    value(value) {
      this.show = value;
    },
    show(value) {
      this.$emit("input", this.show);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>